export default __webpack_public_path__ + "static/media/empty.fd24e0f3.svg";